import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';

/**
 * Component to move selected products to a new library.
 */
@Component({
	selector: 'library-move',
	templateUrl: './library-move.component.html',
	styleUrl: './library-move.component.css'
})
export class LibraryMoveComponent implements OnInit {
	@Input() productGroup: any;

	LOCALIZATION: any;

	library: string = "";
	libraries: any[] = [];
	inprogress: boolean = false;

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.libraries = this.userService.user.properties ? this.userService.user.properties.awlibraryObjectList : [];
	}

	/**
	 * Moves documents to the chosen library.
	 */
	move(): void {
		if (!this.library) {
			this.alertsService.error({
				message: "Destination library is not selected.",
				delay: 5000
			});
			return;
		}

		if (this.productGroup.ids) {
			this.inprogress = true;

			let libname = "the selected library";
			for (let i = 0; i < this.libraries.length; i++) {
				if (this.libraries[i].id == this.library) {
					libname = this.libraries[i].displayNname || this.libraries[i].name;
				}
			}

			this.productService.moveProducts(this.productGroup.ids, { library: this.library }).then(
				(response: any) => {
					this.alertsService.success({
						message: `Documents successfully moved to the ${libname} library.`,
						delay: 5000
					});
					this.close();
				},
				() => {
					this.inprogress = false;
					this.alertsService.error({
						message: "Failed to move the documents."
					});
				}
			);
		}
	};

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
